<template>
  <BaseModalConfirm
    :value="isShowModal"
    :title="$tc('forms.errors.passwordChange.titleModal')"
    :text="$tc('forms.errors.passwordChange.textModal')"
    image="general/attention.webp"
    image-alt="forms.errors.passwordChange.titleModal"
  >
    <template #controls="{ onSubmit }">
      <UiBtn
        color="gray"
        full-width
        :text="$t('regAuthForgot.redirect.regBtn')"
        @click="onSubmit"
      />
    </template>
  </BaseModalConfirm>
</template>

<script>
import BaseModalConfirm from '@/components/Base/Modal/Confirm'

export default {
  name: 'ThePasswordChangeErrorModal',
  components: { BaseModalConfirm },
  props: {
    isShowModal: { type: Boolean },
  },
}
</script>
